import React from "react"
import PropTypes from "prop-types"

const Chevron = ({ className, color }) => (
  <svg
    className={className}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7 10L12 15L17 10"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

Chevron.propTypes = {
  className: PropTypes.string,
  color: PropTypes.string,
}

Chevron.defaultProps = {
  className: "",
  color: "#1C1C1C",
}

export default Chevron
